export const environment = {
  production: true,
  apiUrl: 'https://u2m.api.proxilubpreprod.alzp.tgscloud.net',
  apiPublicUrl: 'https://public.proxilubpreprod.alzp.tgscloud.net',
  oauth: {
    clientId: '8c23c9e2-338e-4604-bf5c-5d9c5981c033',
    issuer: 'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e/v2.0',
    redirectUri: 'https://smeermiddelen-shopmanagertest123.proxilubtest123.totalenergies.be',
    postLogoutUrl: 'https://smeermiddelen-shopmanagertest123.proxilubtest123.totalenergies.be',
    waitForTokenMsec: 1000,
    scope: 'openid profile email api://4e42186d-e929-4508-9e5e-4f1791e5b493/Default',
    requireHttps: false,
    showDebugInformation: false,
    strictDiscoveryDocumentValidation: false,
    // Setting below will automatically add token to headers
    // (make sure to set the proper URL for the API backend)
    resourceServer: {
      allowedUrls: [
        'https://u2m.api.proxilubpreprod.alzp.tgscloud.net',
        'https://public.proxilubpreprod.alzp.tgscloud.net',
      ],
      sendAccessToken: true,
    },
  },
  authorization: {
    requiredRoles: ['shop_admin'],
  },
  errorHandling: {
    httpIgnoreKeys: ['trace', 'details', 'exception_stack'],
  },
  translation: {
    defaultLanguage: 'en',
    fallbackLanguage: 'en',
  },
  tls: {
    roleOptions: ['shop_user', 'shop_admin', 'shop_salesrep', 'shop_reseller'],
    langOptions: ['nl', 'fr'],
    organization: {
      countryOptions: [
        { id: 'NL', name: 'Netherlands' },
        { id: 'BE', name: 'Belgium' },
        { id: 'FR', name: 'France' },
      ],
    },
    telemetry: {
      oilTypes: [
        { id: 0, name: 'Fresh oil' },
        { id: 1, name: 'Waste oil' },
        { id: 2, name: 'Diesel' },
      ],
      tankTypes: [
        { id: 0, name: 'Drum' },
        { id: 1, name: 'Bulk' },
      ],
    },
  },
};
